<template>
  <div class="container-fluid px-2  ">
    <div class="row mb-3 mr-1">

      <button class="btn btn-success rounded-pill" @click="getSms()">
        <span class="ml-1">بارگذاری مجدد</span>
        <b-icon icon="arrow-clockwise"/>
      </button>

      <SmsCharge/>

      <m-a :href="{name:'SendSms'}">
        <button class="btn btn-primary mr-1 rounded-pill">ارسال پیام</button>
      </m-a>
    </div>

    <p>در حالت "پیام شخصی سازی" در هر حالتی که پیام به شماره ارسال نشود، اعتبار پیام های ارسال نشده
       در صورت مشاهده گزارش به حساب شما بازگشت داده خواهد شد.</p>
    <div class="col-12">

      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">شناسه</th>
          <th scope="col">نام پیامک</th>
          <th scope="col">نوع پیامک</th>
          <th scope="col">وضعیت</th>
          <th scope="col">#</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in sms">
          <th>{{ item.id }}</th>
          <td>{{ item.name }}</td>
          <td>{{ typeOfSms(item) }}</td>
          <td>{{ item.status.status_name }}</td>
          <td>
            <button class="btn btn-info" v-b-modal="`sms_report${item.id}`">گزارش</button>

            <b-modal :id="`sms_report${item.id}`" hide-footer>
              <SmsReport :sms="item"/>
            </b-modal>

          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12">

      <pagination :meta="paginationMeta" :on-change-page="changePage"/>

    </div>

  </div>
</template>

<script>
import SmsCharge from "@/plugin/components/dashboard/Sms/SmsCharge.vue";
import {mapGetters} from "vuex";
import SmsReport from "@/plugin/components/dashboard/Sms/SmsReport.vue";
import Pagination from "@/plugin/components/dashboard/Pagination.vue";

export default {
  name: "Sms",
  components: {Pagination, SmsReport, SmsCharge},
  computed: {
    ...mapGetters({
      sms: 'Sms/getSms',
      paginationMeta: "Sms/getPagination",
    })
  },
  methods: {
    getSms(page = 1) {
      this.$store.dispatch('Sms/getSms', page)
    },
    typeOfSms(item) {
      if (item.type) {
        return 'پیام شخصی سازی'
      }
      let result = `قالب آماده (${item.sms_template.name})`
      return result
    },
    changePage(page) {
      this.getSms(page);
    },
  },
  async mounted() {
    await this.getSms()
  }
}
</script>


<style scoped>

</style>